import React from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { formatDateForBE } from "components/Utils/dayjsUtils";
import { Dayjs } from "dayjs";

type DownloadReportButtonProps = {
  reportName: string;
  startDate: Dayjs;
  endDate: Dayjs;
  isLoading: boolean;
  onClick: (queryParams: any) => void;
};
const DownloadReportButton: React.FC<DownloadReportButtonProps> = ({
  reportName,
  startDate,
  endDate,
  isLoading,
  onClick,
}) => {
  return (
    <Button
      style={{ padding: "0 50px" }}
      type="primary"
      disabled={!startDate || !endDate}
      loading={isLoading}
      onClick={() =>
        onClick({
          queryParams: {
            startDate: formatDateForBE(startDate),
            endDate: formatDateForBE(endDate),
          },
        })
      }
    >
      <DownloadOutlined style={{ verticalAlign: "middle" }} />
      {reportName}
    </Button>
  );
};

export default DownloadReportButton;
